import { BotonProcesar } from "../../components/buttons/BotonProcesar"


export const DashboardIncidencias = () => {
    const classSelect = 'p-2 caret-white containerScroll text-white  rounded  bg-zinc-800 text-l focus:outline-none focus:ring-1 focus:ring-blue-500'
    const nivelAtencion = [
        {nombre: 'Alta', codigo: ''},
        {nombre: 'Media', codigo: ''},
        {nombre: 'Baja', codigo: ''},
    ]

    const estados = [
        {nombre:'Nuevo', codigo:''},
        {nombre:'En proceso', codigo:''},
        {nombre:'Finalizado', codigo:''},
    ]

    const areas = [
        {nombre:'Sistemas',codigo:''},
        {nombre:'S. técnico',codigo:''},
        {nombre:'GAC',codigo:''},
    ]

    return(
        <>
            <section className="w-full h-[10%] text-center">
                <span className="text-4xl">Incidencias</span>
                <button className="bg-zinc-700 h-[34px] rounded px-2 w-[100px] absolute right-0 top-4">Actualizar</button>
            </section>
            <section className="w-full h-[90%] overflow-hidden p-2 flex lg:flex-col gap-4 items-end lg:text-xs">
                <section
                    className="w-[20%] relative z-0 p-5 lg:w-full lg:p-1 lg:h-[25%] min-w-[238px]
                    flex flex-col h-[97%] border-[2px] border-blue-600 lg:flex-row"
                >
                    <div
                        className="border-blue-600 border-[2px] font-bold lg:hidden min-w-[195px] lg:min-w-[]
                        text-center p-2 mx-2 absolute -top-6 z-50 bg-black left-[5%] right-[5%]"
                    >Filtros Incidencia</div>
                    <div className="h-[30%] py-2 px-3 text-left lg:w-[33%] min-w-[175px] lg:min-w-[100px]">
                        <span className="font-bold lg:text-xs lg:hidden">Nivel de atención</span>
                        <span className="font-bold hidden lg:block lg:text-xs">N.Atención</span>
                        <section className=" flex flex-col gap-2 pl-3 py-2 lg:p-0 lg:pt-1">
                            {
                                nivelAtencion.length > 0 &&
                                nivelAtencion.map(na =>(
                                    <button
                                        className=" bg-zinc-600 h-[33px] rounded lg:text-xs lg:h-[25px] min-w-[140px]
                                        hover:font-bold hover:bg-zinc-800 text-left px-2 lg:min-w-[40px] lg:max-w-[80px]"
                                    >{na.nombre}</button>
                                ))
                            }
                        </section>
                    </div>
                    <div className="h-[30%] py-2 px-3 text-left lg:w-[33%] min-w-[175px] lg:min-w-[100px]">
                        <span className="font-bold">Estados</span>
                        <section className=" flex flex-col gap-2 pl-3 py-2 lg:p-0 lg:pt-1">
                            {
                                estados.length > 0 &&
                                estados.map(na =>(
                                    <button
                                        className=" bg-zinc-600 h-[33px] rounded lg:text-xs lg:h-[25px] min-w-[140px]
                                        hover:font-bold hover:bg-zinc-800 text-left px-2 lg:min-w-[40px] lg:max-w-[80px]"
                                    >{na.nombre}</button>
                                ))
                            }
                        </section>
                    </div>
                    <div className="h-[30%] py-2 px-3 text-left lg:w-[33%] lg:flex lg:flex-col lg:gap-1 min-w-[175px] lg:min-w-[100px]">
                        <div className="flex flex-col pl-3 py-2 lg:p-0">
                            <span className="font-bold">Áreas</span>
                            <select
                                className={`${classSelect} lg:h-[30px] min-w-[140px] lg:min-w-[40px] lg:max-w-[80px]`}
                            >
                                {
                                    areas.length > 0 &&
                                    areas.map(na =>(
                                        <option>{na.nombre}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="flex flex-col pl-3 py-2 lg:p-0">
                            <span className="lg:font-bold">Personal</span>
                            <select
                            className={`${classSelect} lg:h-[30px] min-w-[140px] lg:min-w-[40px] lg:max-w-[80px]`}></select>
                        </div>
                    </div>
                </section>
                <section className="w-[80%] h-full flex flex-col gap-3 lg:w-full min-w-[570px] lg:min-w-[300px]">
                    <section
                        className="h-[30%] w-full flex gap-3"
                    >
                        <div className="w-[70%] flex gap-3 lg:gap-1">
                            <div
                                className="border-[2px] w-[33%] border-blue-600
                                flex flex-col items-center p-2 lg:justify-center"
                            >
                                <img
                                    alt="" 
                                    src="https://cdn-icons-png.flaticon.com/512/7505/7505544.png"
                                    className="w-[100px] h-[100px] lg:w-[40px] lg:h-[40px]"
                                />
                                <p className="font-bold text-xl lg:text-sm text-center lg:break-words">Total Tickets</p>
                                <p className="font-bold text-4xl lg:text-sm">1</p>
                            </div>
                            <div
                                className="border-[2px] w-[33%] border-blue-600
                                flex flex-col items-center p-2 lg:justify-center"
                            >
                                <img
                                    alt=""
                                    src="https://cdn-icons-png.flaticon.com/512/4539/4539472.png"
                                    className="w-[100px] h-[100px] lg:w-[40px] lg:h-[40px]"
                                />
                                <p className="font-bold text-xl lg:text-sm text-center lg:break-words">Tickets abiertos</p>
                                <p className="font-bold text-4xl lg:text-sm">1</p>
                            </div>
                            <div
                                className="border-[2px] w-[33%] border-blue-600 flex
                                flex-col items-center lg:justify-center p-2"
                            >
                                <img
                                    alt=""
                                    src="https://cdn-icons-png.flaticon.com/512/4817/4817167.png"
                                    className="w-[100px] h-[100px] lg:w-[40px] lg:h-[40px]"
                                />
                                <p className="font-bold text-xl lg:text-sm text-center lg:break-words">Tickets Cerrados</p>
                                <p className="font-bold text-4xl lg:text-sm">1</p>
                            </div>
                        </div>
                        <div className="w-[30%] flex gap-2 border-[2px] border-blue-600">
                        </div>
                    </section>
                    <section className="h-[70%] w-full flex gap-3 ">
                        <section className="w-[60%] h-full flex gap-3 border-blue-600 border-[2px]">
                            <span>Grafico 1</span>
                        </section>
                        <section className="w-[40%] h-full flex gap-3 border-blue-600 border-[2px]">
                            <span>Grafico 2</span>
                        </section>
                    </section>
                </section>
            </section>
        </>
    )
}